<template>
  <div class="flex flex-col gap-3">
    <slot></slot>
  </div>
</template>

<script>
  export default {
    name: "VMapFilterAccordion",
    data(){
      return  {
        context: {
          current: 0,
        }
      }
    },
    computed: {
      getContext(){
        return this.context;
      }
    },
    provide(){
      return {
        context: this.getContext,
        onSetCurrent: this.onSetCurrent
      };
    },
    methods: {
      onSetCurrent(index){
        this.context.current = index;
      }
    }
  }
</script>

<style lang="scss" scoped>

</style>